/**
 * 조직 MSP ID를 사용자 친화적인 이름으로 매핑하는 유틸리티
 */

const ORGANIZATION_MAPPING = {
  // 새로운 MSP ID 매핑
  'KULSMSP': 'KULS',
  'KAISTMSP': 'KAIST',
  'EINSMSP': 'eINS',    // 대문자 EINSMSP
  'eINSMSP': 'eINS',    // 소문자 e + 대문자 INSMSP (실제 블록체인 사용)
  'OrdererMSP': 'Inje University',

  // 직접 매핑 (단순화)
  'KULS': 'KULS',
  'KAIST': 'KAIST',
  'eINS': 'eINS',
  'Gemini': 'Gemini',

  // 기존 MSP ID 호환성 유지 (마이그레이션 기간)
  'CFS1MSP': 'KULS',
  'CY1MSP': 'KAIST',
  'CFS2MSP': 'eINS',

  // 한국어 조직명 -> 표시명 매핑 (백엔드 호환성)
  '부산컨테이너터미널': 'KULS',
  '부산신항만야드': 'KAIST',
  '부산컨테이너운송': 'eINS',
  'Orderer 조직': 'Inje University'
};

/**
 * MSP ID를 사용자 친화적인 조직명으로 변환
 * @param {string} mspId - 원본 MSP ID (예: CY1MSP)
 * @returns {string} 매핑된 조직명 (예: KAIST)
 */
/**
 * 노드 ID를 매핑된 조직명으로 변환
 * @param {string} nodeId - 원본 노드 ID (예: peer0.cfs1.example.com)
 * @returns {string} 매핑된 노드 ID (예: peer0.kuls.example.com)
 */
export function mapNodeId(nodeId) {
  if (!nodeId) return nodeId;

  return nodeId
    .replace(/cfs1/g, 'kuls')
    .replace(/cy1/g, 'kaist')
    .replace(/cfs2/g, 'eins');
}

export function mapOrganizationName(mspId) {
  return ORGANIZATION_MAPPING[mspId] || mspId;
}

export { ORGANIZATION_MAPPING };